var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeatingSystems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#232A2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.52,5.83v13.34c0,1.36-1.1,2.47-2.47,2.47H9.68c-1.36,0-2.47-1.1-2.47-2.47V5.83 c0-1.36,1.1-2.47,2.47-2.47h37.37C48.41,3.37,49.52,4.47,49.52,5.83z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.05,22.12H9.68c-1.63,0-2.95-1.32-2.95-2.95V5.83c0-1.63,1.32-2.95,2.95-2.95h37.37 c1.63,0,2.95,1.32,2.95,2.95v13.34C50,20.79,48.68,22.12,47.05,22.12z M9.68,3.85c-1.1,0-1.99,0.89-1.99,1.99v13.34 c0,1.09,0.89,1.99,1.99,1.99h37.37c1.09,0,1.99-0.89,1.99-1.99V5.83c0-1.1-0.89-1.99-1.99-1.99H9.68z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.46,21.63 12.59,21.63 14.33,17.79 42.73,17.79  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.46,22.12H12.59c-0.16,0-0.32-0.08-0.4-0.22c-0.09-0.14-0.1-0.31-0.03-0.46l1.73-3.85 c0.08-0.17,0.25-0.28,0.44-0.28h28.4c0.19,0,0.36,0.11,0.44,0.28l1.73,3.85c0.07,0.15,0.05,0.32-0.03,0.46 C44.77,22.03,44.62,22.12,44.46,22.12z M13.34,21.15h30.37l-1.3-2.88H14.64L13.34,21.15z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7.21,
    y1: 13.94,
    x2: 49.52,
    y2: 13.94
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.52,14.42H7.21c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h42.31c0.27,0,0.48,0.22,0.48,0.48 S49.78,14.42,49.52,14.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M45.46,8.16c0,0.84-0.68,1.52-1.51,1.52c-0.84,0-1.52-0.68-1.52-1.52c0-0.84,0.68-1.52,1.52-1.52 C44.79,6.64,45.46,7.32,45.46,8.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M43.95,10.16c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,1.99,0.9,1.99,2C45.94,9.27,45.05,10.16,43.95,10.16z  M43.95,7.12c-0.57,0-1.04,0.47-1.04,1.04s0.47,1.04,1.04,1.04c0.57,0,1.03-0.47,1.03-1.04S44.52,7.12,43.95,7.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.15,8.16c0,0.84-0.68,1.52-1.51,1.52c-0.84,0-1.52-0.68-1.52-1.52c0-0.84,0.68-1.52,1.52-1.52 C39.47,6.64,40.15,7.32,40.15,8.16z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M38.64,10.16c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2c1.1,0,1.99,0.9,1.99,2C40.63,9.27,39.73,10.16,38.64,10.16z  M38.64,7.12c-0.57,0-1.04,0.47-1.04,1.04s0.47,1.04,1.04,1.04c0.57,0,1.03-0.47,1.03-1.04S39.2,7.12,38.64,7.12z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M13.94,8.65h-1.92c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h1.92c0.27,0,0.48,0.22,0.48,0.48 S14.21,8.65,13.94,8.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.75,8.65h-1.92c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h1.92c0.27,0,0.48,0.22,0.48,0.48 S19.02,8.65,18.75,8.65z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M23.56,8.65h-1.92c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h1.92c0.27,0,0.48,0.22,0.48,0.48 S23.82,8.65,23.56,8.65z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.63,12.46v2.45H0.48v-2.45c0-0.77,0.63-1.4,1.4-1.4h18.35C21.01,11.06,21.63,11.68,21.63,12.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.63,15.38H0.48C0.22,15.38,0,15.17,0,14.9v-2.45c0-1.04,0.84-1.88,1.88-1.88h18.35 c1.04,0,1.88,0.84,1.88,1.88v2.45C22.12,15.17,21.9,15.38,21.63,15.38z M0.96,14.42h20.19v-1.97c0-0.51-0.41-0.92-0.92-0.92H1.88 c-0.51,0-0.92,0.41-0.92,0.92V14.42z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.48,
    y: 14.9,
    className: "st0",
    width: 21.15,
    height: 27.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.63,43.27H0.48C0.22,43.27,0,43.05,0,42.79V14.9c0-0.27,0.22-0.48,0.48-0.48h21.15 c0.27,0,0.48,0.22,0.48,0.48v27.88C22.12,43.05,21.9,43.27,21.63,43.27z M0.96,42.31h20.19V15.38H0.96V42.31z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.63,42.79v2.45c0,0.77-0.63,1.4-1.4,1.4H1.88c-0.77,0-1.4-0.63-1.4-1.4v-2.45H21.63z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M20.23,47.12H1.88C0.84,47.12,0,46.27,0,45.23v-2.45c0-0.27,0.22-0.48,0.48-0.48h21.15 c0.27,0,0.48,0.22,0.48,0.48v2.45C22.12,46.27,21.27,47.12,20.23,47.12z M0.96,43.27v1.97c0,0.51,0.41,0.92,0.92,0.92h18.35 c0.51,0,0.92-0.41,0.92-0.92v-1.97H0.96z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M12.84,33.36c0,1.98-1.78,3.54-3.83,3.16c-1.22-0.22-2.23-1.17-2.52-2.38c-0.37-1.57,0.42-3.02,1.68-3.66 v-8.09c0-0.8,0.65-1.44,1.44-1.44h0c0.8,0,1.44,0.65,1.44,1.44v8.09C12.11,31,12.84,32.09,12.84,33.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M9.61,37.05c-0.23,0-0.46-0.02-0.69-0.06c-1.41-0.26-2.57-1.36-2.9-2.74c-0.38-1.6,0.3-3.22,1.67-4.05v-7.81 c0-1.06,0.86-1.92,1.92-1.92s1.92,0.86,1.92,1.92v7.8c1.11,0.67,1.78,1.85,1.78,3.16c0,1.1-0.48,2.14-1.33,2.84 C11.32,36.75,10.48,37.05,9.61,37.05z M9.62,21.43c-0.53,0-0.96,0.43-0.96,0.96v8.09c0,0.18-0.1,0.35-0.26,0.43 c-1.14,0.57-1.73,1.85-1.43,3.12c0.24,1.02,1.1,1.83,2.14,2.02c0.83,0.15,1.64-0.06,2.28-0.58c0.62-0.52,0.98-1.29,0.98-2.1 c0-1.04-0.58-1.98-1.51-2.45c-0.16-0.08-0.27-0.25-0.27-0.43v-8.09C10.58,21.86,10.15,21.43,9.62,21.43z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.87,28.85h-1.92c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h1.92c0.27,0,0.48,0.22,0.48,0.48 S16.13,28.85,15.87,28.85z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.87,26.38h-1.92c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h1.92c0.27,0,0.48,0.22,0.48,0.48 S16.13,26.38,15.87,26.38z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.87,24.04h-1.92c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h1.92c0.27,0,0.48,0.22,0.48,0.48 S16.13,24.04,15.87,24.04z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.02,45.19H9.13c-0.27,0-0.48-0.22-0.48-0.48c0-0.27,0.22-0.48,0.48-0.48h2.88c0.27,0,0.48,0.22,0.48,0.48 C12.5,44.98,12.28,45.19,12.02,45.19z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.22,9.62H6.73v0.96h13.49c1.04,0,1.89,0.85,1.89,1.89v9.66h0.96v-9.66C23.08,10.9,21.8,9.62,20.22,9.62z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.02,13.46H10.1c-0.27,0-0.48-0.22-0.48-0.48s0.22-0.48,0.48-0.48h1.92c0.27,0,0.48,0.22,0.48,0.48 S12.28,13.46,12.02,13.46z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatingSystems);
export default __webpack_public_path__ + "static/media/heating-systems.eb1a024168f9a4884df4472db3f8fd96.svg";
export { ForwardRef as ReactComponent };